// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611031905/js/" + chunkId + "." + {"44":"7a5e6a39","225":"e8a70aff","481":"103a01dc","486":"5ecf5de3","770":"6983fec5"}[chunkId] + ".0.7711685679459053.chunk.js";
};